export default "<div class=\"spinner-border spinner\" role=\"status\" [ngStyle]=\"spinnerStyle\">\r\n  <span class=\"sr-only\">Loading...</span>\r\n</div>"